import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useDispatch, useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { orange, primary, shadowSm } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { height, noMoney } from "../../imports";
import { noModal } from "../../redux/modal/modalAction";
import { ScrollView } from "react-native-gesture-handler";
import * as Linking from "expo-linking";
import { useNavigation } from "@react-navigation/native";
import setNotificationRead from "../../api/notification/setNotificationRead";

export default function NotificationModal({ notifications }) {

  const navigation = useNavigation();
  const modal = useSelector((store) => store.modal);
  const dispatch = useDispatch();
  const openNotification = (id, type, value) => {
    if (type === "Advertising") {
      Linking.openURL(value);
      setNotificationRead(id)
        .then(() => {})
        .catch((err) => {});
      dispatch(noModal());
      return;
    }
    if (value !== null) {
      value = JSON.parse(value);
    }
    if (type === "Chat") {
      navigation.navigate("ConsultationNavigator", {
        screen: "Chat",
        initial: false,
        params: { id: value.id, childId: value.childId },
      });
      setNotificationRead(id)
        .then(() => {})
        .catch((err) => {});
      dispatch(noModal());
      return;
    }
    if (type === "Blog") {
      navigation.navigate("HomeNavigator", {
        screen: "Tutorial",
        initial: false,
        params: { id: value.id },
      });
      setNotificationRead(id)
        .then(() => {})
        .catch((err) => {});
      dispatch(noModal());
      return;
    }
    navigation.navigate("TestNavigator");
    setNotificationRead(id)
      .then(() => {})
      .catch((err) => {});
    dispatch(noModal());
    return;
  };
  const colorList = [
    "#48A9C2",
    "#FF9356",
    "#E2F0CB",
    "#A7CA8D",
    "#9371BE",
    "#FFe986",
  ];
  return (
    <MyModal
      isVisible={modal.notificationModal}
      headerText={translate("notifications")}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{
          width: "100%",
          maxHeight: height / 1.5,
          overflow: "hidden",
        }}
        contentContainerStyle={{ alignItems: "center" }}
      >
        <View
          onStartShouldSetResponder={() => true}
          style={{ width: "99%", marginBottom: 10, minHeight: 200 }}
        >
          {notifications.map((notification, index) => (
            <TouchableOpacity
              key={index}
              onPress={() =>
                openNotification(
                  notification.id,
                  notification.respective,
                  notification.respective === "Advertising"
                    ? notification.respectiveLink
                    : notification.respectiveID
                )
              }
              style={{
                ...shadowSm,
                borderRadius: 3,
                borderLeftWidth: 6,
                borderRightWidth: 6,
                borderColor: colorList[index % 5],
                padding: 5,
                paddingHorizontal: 10,
                marginVertical: 10,
              }}
            >
              <MyText>{`${notification.descreptions}`}</MyText>
            </TouchableOpacity>
          ))}
        </View>
        {/* <View style={{ marginBottom: 10 }}>
          <MyButton
            text={translate("got it")}
            onPress={() => dispatch(noModal())}
          />
        </View> */}
      </ScrollView>
    </MyModal>
  );
}
